'use client';

import { c as _c } from "react/compiler-runtime";
import avatarIcon from '@public/images/avatar.svg';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { isActiveNavItem, isNavItemVisible } from '@src/components/TopNavV6/utils';
import { useSession } from '@src/hooks/useSession';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import cartIcon from '../assets/desktop-cart-icon.svg';
export const TopNavV6Desktop = props => {
  const $ = _c(57);
  const {
    logo,
    navItems,
    cartHref: t0,
    joinBodiHref: t1,
    loginLabel,
    joinBodiLabel,
    onCartClick,
    onLoginClick,
    onJoinBodiClick,
    onAccountClick,
    account
  } = props;
  const cartHref = t0 === undefined ? "#cart" : t0;
  const joinBodiHref = t1 === undefined ? "/join" : t1;
  const {
    setAccountExpanded
  } = useTopNavV6();
  const {
    user,
    getLoginHref
  } = useSession();
  let t2;
  if ($[0] !== getLoginHref) {
    t2 = getLoginHref();
    $[0] = getLoginHref;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const loginHref = t2;
  const pathname = usePathname();
  let handleAccountClick;
  let joinBodiButtonLabel;
  let loginButtonLabel;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== account?.bodiCta?.title || $[3] !== account?.logInCopy || $[4] !== joinBodiLabel || $[5] !== loginLabel || $[6] !== logo || $[7] !== navItems || $[8] !== onAccountClick || $[9] !== pathname || $[10] !== setAccountExpanded || $[11] !== user) {
    const {
      edit
    } = getBuilderPreviewMode();
    loginButtonLabel = loginLabel ?? account?.logInCopy ?? "Login";
    joinBodiButtonLabel = joinBodiLabel ?? account?.bodiCta?.title ?? "Join BODi";
    let t10;
    if ($[22] !== onAccountClick || $[23] !== setAccountExpanded) {
      t10 = () => {
        if (onAccountClick) {
          onAccountClick();
        } else {
          setAccountExpanded(true);
        }
      };
      $[22] = onAccountClick;
      $[23] = setAccountExpanded;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    handleAccountClick = t10;
    t7 = "Main";
    t8 = "relative z-50 flex h-16 w-full items-center border-b border-bodi-gray-dark bg-bodi-black-text px-4";
    t9 = "Desktop - Nav Bar - Signed In";
    t5 = "mx-auto flex h-full w-full max-w-[1680px] items-center";
    if ($[25] !== logo) {
      t6 = logo?.src && <div className="mr-4 self-center"><LocalizedLink href={logo.href ?? "/"} className="flex shrink-0 items-center"><Image src={logo.src} width={logo.width ?? 100} height={logo.height ?? 33} alt={logo.altText ?? "Logo"} /></LocalizedLink></div>;
      $[25] = logo;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    t3 = "flex h-full items-end self-end";
    t4 = navItems?.filter(item => edit || isNavItemVisible(item.visibility, user)).map((item_0, index) => {
      const url = user && item_0.authenticatedHref ? item_0.authenticatedHref : item_0.href ?? "#";
      const isActive = !!item_0.isActive || isActiveNavItem(url, pathname);
      return <LocalizedLink key={`nav-item-${index}`} href={url} onClick={item_0.onClick} className={cn("box-border flex h-full items-center justify-center border-r-0 border-b-[3px] border-transparent px-3 py-4 font-lateral text-body-lg leading-none transition-colors", {
        "border-bodi-accent-bright-500 text-white hover:underline": isActive,
        "text-bodi-gray-butters hover:text-bodi-white": !isActive
      })}>{item_0.title}</LocalizedLink>;
    });
    $[2] = account?.bodiCta?.title;
    $[3] = account?.logInCopy;
    $[4] = joinBodiLabel;
    $[5] = loginLabel;
    $[6] = logo;
    $[7] = navItems;
    $[8] = onAccountClick;
    $[9] = pathname;
    $[10] = setAccountExpanded;
    $[11] = user;
    $[12] = handleAccountClick;
    $[13] = joinBodiButtonLabel;
    $[14] = loginButtonLabel;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    handleAccountClick = $[12];
    joinBodiButtonLabel = $[13];
    loginButtonLabel = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t10;
  if ($[27] !== t3 || $[28] !== t4) {
    t10 = <div className={t3}>{t4}</div>;
    $[27] = t3;
    $[28] = t4;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("ml-auto flex h-full items-center gap-4");
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src={cartIcon} width={300} height={150} alt="Shopping cart" className="h-6 w-6 object-cover" />;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== cartHref || $[33] !== onCartClick) {
    t13 = <div className="flex h-11 w-7 items-center justify-center"><Link className="relative" data-testid="cartBtn" href={cartHref} onClick={onCartClick} scroll={false}>{t12}</Link></div>;
    $[32] = cartHref;
    $[33] = onCartClick;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== handleAccountClick || $[36] !== joinBodiButtonLabel || $[37] !== joinBodiHref || $[38] !== loginButtonLabel || $[39] !== loginHref || $[40] !== onJoinBodiClick || $[41] !== onLoginClick || $[42] !== user) {
    t14 = !user ? <div className="flex items-center gap-2"><a href={loginHref} onClick={onLoginClick}><Button size="small" variant="black" className="h-auto border border-solid border-bodi-gray-medium px-4! pt-[6px]! pb-[5px]!" contentClassName="px-0 text-body-md font-semibold leading-[18px] tracking-normal">{loginButtonLabel}</Button></a><LocalizedLink href={joinBodiHref} onClick={onJoinBodiClick}><Button size="small" className="h-auto border border-x-0 border-solid border-bodi-black-text px-4! pt-[6px]! pb-[5px]!" contentClassName="px-0 text-body-md font-semibold leading-[18px] tracking-normal">{joinBodiButtonLabel}</Button></LocalizedLink></div> : <div className="flex items-center gap-4"><button onClick={handleAccountClick} data-testid="accountBtn" className="flex items-center justify-center"><Image src={avatarIcon} width={22} height={22} className="size-[22px] object-cover" alt="Account icon" /></button>{!user?.hasBodiAccess && <LocalizedLink href={joinBodiHref} onClick={onJoinBodiClick}><Button size="small" className="h-auto border border-x-0 border-solid border-bodi-black-text px-4 pt-[6px] pb-[5px]" contentClassName="px-0 text-body-md font-semibold leading-[18px] tracking-normal">{joinBodiButtonLabel}</Button></LocalizedLink>}</div>;
    $[35] = handleAccountClick;
    $[36] = joinBodiButtonLabel;
    $[37] = joinBodiHref;
    $[38] = loginButtonLabel;
    $[39] = loginHref;
    $[40] = onJoinBodiClick;
    $[41] = onLoginClick;
    $[42] = user;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t13 || $[45] !== t14) {
    t15 = <div className={t11}>{t13}{t14}</div>;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== t10 || $[48] !== t15 || $[49] !== t5 || $[50] !== t6) {
    t16 = <div className={t5}>{t6}{t10}{t15}</div>;
    $[47] = t10;
    $[48] = t15;
    $[49] = t5;
    $[50] = t6;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== t16 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9) {
    t17 = <nav aria-label={t7} className={t8} data-name={t9}>{t16}</nav>;
    $[52] = t16;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  return t17;
};